/**
 * TelegramGuide - Trang hướng dẫn tham gia Telegram Channel
 * Giải thích cách nhận tin tự động và các bước thực hiện
 */
import { Link } from 'react-router-dom'
import { HiOutlineArrowLeft, HiOutlineCheckCircle } from 'react-icons/hi'
import { FaTelegramPlane } from 'react-icons/fa'

const TELEGRAM_CHANNEL_URL = 'https://t.me/+FzvKdNbv_rZiMjI1'

// Hình minh họa (placeholder - thay bằng hình thực tế)
const STEP_IMAGES = {
  step1: '/images/telegram-guide/step1.png',
  step2: '/images/telegram-guide/step2.png',
  step3: '/images/telegram-guide/step3.png',
}

export default function TelegramGuide() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      {/* Nút quay lại */}
      <Link
        to="/news"
        className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-6 font-medium"
      >
        <HiOutlineArrowLeft className="w-5 h-5 mr-1" />
        Quay lại Tin tức
      </Link>

      {/* Header */}
      <div className="text-center mb-10">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-sky-100 text-sky-600 mb-4">
          <FaTelegramPlane className="w-10 h-10" />
        </div>
        <h1 className="text-3xl font-bold text-gray-900 mb-3">
          Nhận tin tức qua Telegram
        </h1>
        <p className="text-lg text-gray-600 max-w-xl mx-auto">
          Không bỏ lỡ tin nóng BĐS – Nhận thông báo mới nhất ngay trên điện thoại của bạn
        </p>
      </div>

      {/* Lợi ích */}
      <div className="bg-gradient-to-r from-sky-50 to-blue-50 rounded-2xl p-6 mb-10">
        <h2 className="font-semibold text-gray-900 mb-4">Lợi ích khi tham gia:</h2>
        <div className="grid sm:grid-cols-2 gap-4">
          <div className="flex items-start gap-3">
            <HiOutlineCheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" />
            <div>
              <p className="font-medium text-gray-900">Tin tức realtime</p>
              <p className="text-sm text-gray-600">Nhận ngay khi có tin mới</p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <HiOutlineCheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" />
            <div>
              <p className="font-medium text-gray-900">Tin nóng mỗi ngày</p>
              <p className="text-sm text-gray-600">Tổng hợp tin quan trọng</p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <HiOutlineCheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" />
            <div>
              <p className="font-medium text-gray-900">Miễn phí 100%</p>
              <p className="text-sm text-gray-600">Không mất phí sử dụng</p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <HiOutlineCheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" />
            <div>
              <p className="font-medium text-gray-900">Hủy bất kỳ lúc nào</p>
              <p className="text-sm text-gray-600">Rời nhóm khi không cần</p>
            </div>
          </div>
        </div>
      </div>

      {/* Các bước */}
      <div className="mb-10">
        <h2 className="text-xl font-bold text-gray-900 mb-6">
          Hướng dẫn tham gia (3 bước)
        </h2>

        <div className="space-y-8">
          {/* Bước 1 */}
          <div className="flex gap-4">
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-sky-600 text-white flex items-center justify-center font-bold">
              1
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-gray-900 mb-2">
                Mở ứng dụng Telegram trên điện thoại
              </h3>
              <p className="text-gray-600 mb-3">
                Nếu chưa có, tải Telegram từ App Store (iPhone) hoặc Google Play (Android)
              </p>

              <div className="bg-gray-100 rounded-xl p-4 text-center">
                <div className="inline-flex gap-3">
                  <a
                    href="https://apps.apple.com/app/telegram-messenger/id686449807"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-4 py-2 bg-black text-white rounded-lg text-sm font-medium hover:bg-gray-800"
                  >
                    App Store
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=org.telegram.messenger"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700"
                  >
                    Google Play
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Bước 2 */}
          <div className="flex gap-4">
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-sky-600 text-white flex items-center justify-center font-bold">
              2
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-gray-900 mb-2">
                Nhấn vào nút “Tham gia Channel” bên dưới
              </h3>
              <p className="text-gray-600 mb-3">
                Hệ thống sẽ tự động mở Telegram và hiển thị kênh tin tức BĐS
              </p>

              <a
                href={TELEGRAM_CHANNEL_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-sky-600 text-white font-medium hover:bg-sky-700 transition-colors shadow-lg shadow-sky-200"
              >
                <FaTelegramPlane className="w-5 h-5" />
                Tham gia Channel
              </a>
            </div>
          </div>

          {/* Bước 3 */}
          <div className="flex gap-4">
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-sky-600 text-white flex items-center justify-center font-bold">
              3
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-gray-900 mb-2">
                Nhấn “Join” để tham gia kênh
              </h3>
              <p className="text-gray-600 mb-3">
                Sau khi tham gia, bạn sẽ tự động nhận được thông báo khi có tin mới
              </p>

              <div className="bg-green-50 border border-green-200 rounded-xl p-4">
                <div className="flex items-center gap-3">
                  <HiOutlineCheckCircle className="w-8 h-8 text-green-500" />
                  <div>
                    <p className="font-medium text-green-800">Hoàn tất!</p>
                    <p className="text-sm text-green-600">
                      Bạn đã sẵn sàng nhận tin tức mới
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ */}
      <div className="bg-gray-50 rounded-2xl p-6 mb-10">
        <h2 className="font-semibold text-gray-900 mb-4">
          Câu hỏi thường gặp
        </h2>

        <div className="space-y-4">
          <div>
            <h3 className="font-medium text-gray-900">
              Tin tức được cập nhật khi nào?
            </h3>
            <p className="text-gray-600 text-sm mt-1">
              Tin nóng được gửi ngay khi có. Tổng hợp tin quan trọng gửi vào 8h sáng mỗi ngày.
            </p>
          </div>

          <div>
            <h3 className="font-medium text-gray-900">
              Làm sao để ngừng nhận thông báo?
            </h3>
            <p className="text-gray-600 text-sm mt-1">
              Mở kênh trong Telegram, nhấn “Leave” hoặc “Mute” để tắt thông báo.
            </p>
          </div>

          <div>
            <h3 className="font-medium text-gray-900">
              Kênh này chỉ dành cho nhân viên DXMT?
            </h3>
            <p className="text-gray-600 text-sm mt-1">
              Đúng, đây là kênh nội bộ dành cho nhân viên kinh doanh Đất Xanh Miền Trung.
            </p>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="text-center">
        <a
          href={TELEGRAM_CHANNEL_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 px-8 py-4 rounded-xl bg-gradient-to-r from-sky-500 to-blue-600 text-white font-semibold text-lg hover:from-sky-600 hover:to-blue-700 transition-all shadow-xl shadow-sky-200"
        >
          <FaTelegramPlane className="w-6 h-6" />
          Tham gia ngay
        </a>
        <p className="text-sm text-gray-500 mt-3">
          Miễn phí – Chỉ mất 30 giây
        </p>
      </div>
    </div>
  )
}
